import "../../assets/css/affiliate.css";
import "../../assets/css/tooltip.css";

import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchingUser, fetchingUserSuccess } from "../../redux/actions";
import { withRouter } from "react-router-dom";
import {
  formatNumber,
  getUrl,
  setClassNameCondition,
  showNotification,
  isDesktop, formatNumberDecimal,
} from "../../lib/helper";
import api from "../../lib/api";
import DataTable from "react-data-table-component";
import moment from "moment";
import DateRangePicker from "../../lib/custom/DateRangePicker";
import Network from "./network";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Commission from "./commission/Commission";
import { types } from "redux-act";
import Upgrade from "./upgrade/Upgrade";
import { getVipData } from "../../lib/api/affiliate";
import { useSnackbar } from "notistack";
import { withTranslation } from "react-i18next";
class Affiliate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_show_tooltip: false,
      is_show_buy: false,
      agree_vip: false,
      duty_vip: false,
      selected_tab: "general",
      trade_commission: 0,
      vip_commission: 0,
      vip_data: null,
      chartOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "areaspline",
          backgroundColor: "#181A20",
          height: null,
        },
        title: {
          text: null,
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          type: "datetime",
          accessibility: {
            rangeDescription: this.formatRangeDateDataForChart(),
          },
          labels: {
            format: "{value:%m/%d}",
            style: {
              color: "#fff",
            },
          },
          gridLineWidth: 1,
          gridLineDashStyle: "Dash",
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: { style: { color: "#e22a67" } },
            gridLineWidth: 0,
          },
          {
            title: {
              text: null,
            },
            opposite: true,
            labels: { style: { color: "#30d6ce" } },
            gridLineWidth: 0,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
            pointStart: Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ),
            pointIntervalUnit: "day",
          },
          areaspline: {
            fillOpacity: 0.5,
          },
        },
        series: [
          {
            name: "Tổng số nhà giao dịch mới",
            color: "#04c793",
            data: [
              38000, 37300, 37892, 38564, 36770, 36026, 34978, 35657, 35620,
              35971, 36409, 36435, 34643, 34956, 33199, 31136, 30835, 31611,
              30666, 30319, 31766,
            ],
            yAxis: 1,
          },
          {
            name: "Tổng số thành viên vip",
            color: "#00b6ff",
            data: [
              22534, 23599, 24533, 25195, 25896, 27635, 29173, 32646, 35686,
              37709, 39143, 32423, 32434, 12213, 32434, 23123, 37773, 42556,
              43820, 46445, 50048,
            ],
            yAxis: 1,
          },
          {
            name: "Tổng số hoa hồng mới",
            color: "#fa4b62",
            data: [
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            ],
            yAxis: 0,
          },
        ],
      },
      monthTab: "current",

      commission: {
        page: 1,
        per_page: 10,
        data: [],
        total: 0,
        sort_selector: "created_at",
        sort_direction: "desc",
        filter_from: moment(),
        filter_to: moment(),
      },
      userRanking: "rank5",
      isOpenModal: false,
    };
    this.toolTipRef = React.createRef();
    this.columnsCommission = [
      {
        name: "Mã giao dịch",
        selector: "code",
        sortable: false,
      },
      {
        name: "Thời gian",
        selector: "created_at",
        sortable: true,
      },
      {
        name: "Loại hoa hồng",
        selector: "transaction_type_label",
        data: "transaction_type",
        sortable: false,
        format: (row, index) => (
          <span className={"transaction_type " + row.transaction_type}>
            {row.transaction_type_label}
          </span>
        ),
        allowOverflow: true,
      },
      {
        name: "Đến từ",
        selector: "commission_ref_name",
        data: "commission_member_id",
        sortable: true,
        format: (row, index) => (
          <span>
            <b>(F{row.commission_level})</b> {row.commission_ref_name}
          </span>
        ),
        allowOverflow: true,
      },
      {
        name: "Giá trị ($)",
        selector: "value",
        sortable: true,
        right: true,
        format: (row, index) => (
          <span style={{ color: row.value < 0 ? "red" : "black" }}>
            {formatNumber(row.value)}
          </span>
        ),
      },
    ];
    this.chartRef = React.createRef();
  }

  formatRangeDateDataForChart() {
    let rangeDate = "";
    const currentDate = new Date();

    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );

    // Hàm để lấy hậu tố cho ngày
    function getDaySuffix(day) {
      const suffix = ["th", "st", "nd", "rd"];
      const val = day % 100;
      return suffix[(val - 20) % 10] || suffix[val] || suffix[0];
    }

    // Hàm định dạng ngày theo kiểu "April 1st 2024"
    function formatDateWithSuffix(date) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const day = date.getDate();
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      return `${month} ${day}${getDaySuffix(day)} ${year}`;
    }

    const firstDayFormatted = formatDateWithSuffix(firstDayOfMonth);
    const lastDayFormatted = formatDateWithSuffix(lastDayOfMonth);

    rangeDate = `Range: ${firstDayFormatted} to ${lastDayFormatted}.`;

    return rangeDate;
  }

  onClickModel = (type) => () => {
    this.setState({ [type]: !this.state[type] });
  };

  onCopy = () => {
    const { enqueueSnackbar } = this.props;
    let { username, ref_code } = this.props.memberReducer;
    navigator.clipboard
      .writeText(getUrl("register?r=" + ref_code))
      .then(() => {
        showNotification(enqueueSnackbar, {
          type: "success",
          message: "Đã sao chép vào bộ nhớ",
        });
      })
      .catch((e) => {
        showNotification(enqueueSnackbar, { type: "danger", message: e.message });
      });
  };
  onCopy2 = () => {
    const { enqueueSnackbar } = this.props;
    let { username, ref_code } = this.props.memberReducer;
    navigator.clipboard
      .writeText(ref_code)
      .then(() => {
        showNotification(enqueueSnackbar, {
          type: "success",
          message: "Đã sao chép vào bộ nhớ",
        });
      })
      .catch((e) => {
        showNotification(enqueueSnackbar, { type: "danger", message: e.message });
      });
  };

  onBuyVip = () => {
    let { enqueueSnackbar } = this.props;
    this.onClickModel("is_show_buy")();
    api.postBuyVip().then(({ message, success, data }) => {
      showNotification(enqueueSnackbar, {
        message: message,
        type: success ? "success" : "danger",
      });
      if (success) {
        this.props.fetchingUser();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    });
  };

  onChangeAgreeVip = () => {
    this.setState({ agree_vip: !this.state.agree_vip });
  };
  onChangeDutyVip = () => {
    this.setState({ duty_vip: !this.state.duty_vip });
  };
  onSelectTab = (tab) => (e) => {
    e && e.preventDefault();
    this.setState({ selected_tab: tab }, () => {
      if (tab === "commission") {
        api.getCommission().then(({ data, success }) => {
          success &&
            Object.keys(data).forEach((key) =>
              this.setState({ [key]: data[key] })
            );
        });
        this.loadTransaction();
      }
    });
  };

  onSortTransaction = (column, sortDirection) => {
    let { commission } = this.state;
    this.setState(
      {
        commission: {
          ...commission,
          sort_selector: column.data || column.selector,
          sort_direction: sortDirection,
        },
      },
      this.loadTransaction
    );
  };

  loadTransaction = () => {
    let { commission } = this.state;
    let {
      page,
      per_page,
      sort_selector,
      sort_direction,
      filter_from,
      filter_to,
    } = commission;
    api
      .getTransaction({
        limit: per_page,
        page,
        sort_selector,
        sort_direction,
        filter_from: filter_from.format("YYYY-MM-DD"),
        filter_to: filter_to.format("YYYY-MM-DD"),
        transaction_type: "ref",
      })
      .then(({ data, success }) => {
        if (success) {
          let { commission } = this.state;
          this.setState({
            commission: { ...commission, data: data.data, total: data.total },
          });
        }
      });
  };

  handlePageChangeCommission = (page) => {
    let { commission } = this.state;
    this.setState(
      { commission: { ...commission, page } },
      this.loadTransaction
    );
  };

  handlePerRowsChangeCommission = (per_page) => {
    let { commission } = this.state;
    this.setState(
      { commission: { ...commission, per_page } },
      this.loadTransaction
    );
  };

  handleChangeDateRange = (start, end) => {
    let { commission } = this.state;
    this.setState(
      { commission: { ...commission, filter_from: start, filter_to: end } },
      this.loadTransaction
    );
  };
  handleSelectMonthTab = (tab) => {
    this.setState({ monthTab: tab });
  };
  fillMissingDays(data) {
    // Lấy ngày hiện tại và ngày đầu tháng
    const currentDate = new Date();
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    startOfMonth.setHours(startOfMonth.getHours() + 8);
    // Tạo mảng các ngày trong tháng từ ngày đầu tháng đến ngày hiện tại
    const allDates = [];
    let tempDate = new Date(startOfMonth);

    while (tempDate <= currentDate) {
      allDates.push(tempDate.toISOString().split("T")[0]); // Định dạng ngày theo "YYYY-MM-DD"
      tempDate.setDate(tempDate.getDate() + 1); // Tăng ngày lên
    }

    // Mảng kết quả điền dữ liệu
    const filledData = {};

    allDates.forEach((date) => {
      // Kiểm tra nếu ngày có trong dữ liệu
      if (data[date]) {
        filledData[date] = data[date];
      } else {
        // Nếu không có trong dữ liệu, điền giá trị là dữ liệu của ngày trước đó
        const prevDate = allDates[allDates.indexOf(date) - 1];
        if (prevDate) {
          filledData[date] = filledData[prevDate];
        } else {
          // Nếu là ngày đầu tháng và không có dữ liệu, gán giá trị là 0
          filledData[date] = 0;
        }
      }
    });

    return filledData;
  }
  fillMissingDaysLastMonth(data) {
    let lastMonth_firstDate = Object.keys(data)[0];
    // Lấy ngày đầu tiên có dữ liệu và ngày cuối tháng
    const startDate = new Date(lastMonth_firstDate);
    const endOfMonth = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      0
    );
    endOfMonth.setHours(endOfMonth.getHours());
    // Tạo mảng các ngày trong tháng từ ngày đầu có dữ liệu đến ngày cuối tháng
    const allDates = [];
    let tempDate = new Date(endOfMonth);

    while (tempDate >= startDate) {
      allDates.push(startDate.toISOString().split("T")[0]); // Định dạng ngày theo "YYYY-MM-DD"
      startDate.setDate(startDate.getDate() + 1);
    }

    // Mảng kết quả điền dữ liệu
    const filledData = {};

    allDates.forEach((date) => {
      // Kiểm tra nếu ngày có trong dữ liệu
      if (data[date]) {
        filledData[date] = data[date];
      } else {
        // Nếu không có trong dữ liệu, điền giá trị là dữ liệu của ngày trước đó
        const prevDate = allDates[allDates.indexOf(date) - 1];
        if (prevDate) {
          filledData[date] = filledData[prevDate];
        } else {
          // Nếu là ngày đầu tháng và không có dữ liệu, gán giá trị là 0
          filledData[date] = 0;
        }
      }
    });
    return filledData;
  }
  getChartData() {
    const currentDate = new Date().getDate();
    const ArrIfNull = Array(currentDate).fill(0);
    let pointStart;
    if (this.state.monthTab === "current") {
      let missingTrade = {};
      let missingVipMember = {};
      let comissionData = {};
      if (this.state?.vip_data?.totalMemberTradeCurrentMonth) {
        missingTrade =
          this.fillMissingDays(
            this.state?.vip_data?.totalMemberTradeCurrentMonth
          ) || {};
      }
      if (this.state?.vip_data?.totalVipCurrentMonth) {
        missingVipMember =
          this.fillMissingDays(this.state?.vip_data?.totalVipCurrentMonth) ||
          {};
      }
      if (this.state?.vip_data?.totalCommissionCurrentMonth) {
        comissionData =
          this.fillMissingDays(
            this.state?.vip_data?.totalCommissionCurrentMonth
          ) || {};
      }

      const chartTradeData = Object.values(missingTrade || 0) || ArrIfNull;
      this.chartRef?.current?.chart?.series[0]?.setData(chartTradeData);
      const chartVipMemberData =
        Object.values(missingVipMember || 0) || ArrIfNull;
      this.chartRef?.current?.chart?.series[1]?.setData(chartVipMemberData);
      const chartComissionData = Object.values(comissionData || 0) || ArrIfNull;
      this.chartRef?.current?.chart?.series[2]?.setData(chartComissionData);
    } else {
      let missingTrade = {};
      let missingVipMember = {};
      let comissionData = {};

      //Mảng ngày nếu tháng trước người dùng không có dữ liệu
      if (this.state?.vip_data?.totalMemberTradeLastMonth) {
        missingTrade =
          this.fillMissingDaysLastMonth(
            this.state?.vip_data?.totalMemberTradeLastMonth
          ) || {};
      }
      if (this.state?.vip_data?.totalVipLastMonth) {
        missingVipMember =
          this.fillMissingDaysLastMonth(this.state?.vip_data?.totalVipLastMonth) || {};
      }
      if (this.state?.vip_data?.totalCommissionLastMonth) {
        comissionData =
          this.fillMissingDaysLastMonth(
            this.state?.vip_data?.totalCommissionLastMonth
          ) || {};
      }
      const chartTradeData = Object.values(missingTrade).length > 0 ? Object.values(missingTrade) : ArrIfNull;
      const chartVipMemberData = Object.values(missingVipMember).length > 0 ? Object.values(missingVipMember) : ArrIfNull;
      const chartComissionData = Object.values(comissionData).length > 0 ? Object.values(comissionData) : ArrIfNull;

      // Lấy điểm bắt đầu là ngày này tháng trước nếu k có data
      const previousMonthDate = () => {
        const currentDate = new Date();
        const previousMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());

        const year = previousMonthDate.getFullYear().toString(); // Get last two digits of the year
        const month = (previousMonthDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
        const day = previousMonthDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
      }
      // Set lại điểm bắt đầu cho biểu đồ
      const dateData = Object.keys(missingTrade).length !== 0 ? Object.keys(missingTrade)[0] : previousMonthDate();
      const startDate = new Date(dateData);
      pointStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      this.chartRef?.current?.chart?.series[0]?.update({
        pointStart: pointStart,
        data: chartTradeData
      });
      this.chartRef?.current?.chart?.series[1]?.update({
        pointStart: pointStart,
        data: chartVipMemberData
      });
      this.chartRef?.current?.chart?.series[2]?.update({
        pointStart: pointStart,
        data: chartComissionData
      });
    }
  }
  componentDidUpdate(prevState, state) {
    this.getChartData();
  }
  componentDidMount() {
    const { vip } = this.props.memberReducer;
    this.setState({ userRanking: "rank" + vip?.id });
    this.handleGetVipData();
    this.getChartData();
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    // Kiểm tra nếu click bên ngoài phần tử
    if (
      this.toolTipRef.current &&
      !this.toolTipRef.current.contains(event.target)
    ) {
      this.setState({ is_show_tooltip: false });
    }
  };
  handleGetVipData = async () => {
    const memberData = this.props.memberReducer;
    const result = await getVipData();

    if (result.code === 200) {

      this.setState({ vip_data: result.data });
    }
  };
  getRankIconForUser = (userRank) => {
    const urls = {
      rank1: "images/rank1.png",
      rank2: "images/rank2.png",
      rank3: "images/rank3.png",
      rank4: "images/rank4.png",
      rank5: "images/rank5.png",
      rank6: "images/rank6.png",
      rank7: "images/rank7.png",
      rank8: "images/rank8.png",
    };
    return urls[userRank] || null;
  };
  handleUpdateUserRank = (userRank) => {
    this.setState({ userRanking: "rank" + userRank });
  };
  handleChangeTab = (item) => {
    this.setState({ selected_tab: item });
  };
  handleToggleModal = () => {
    this.setState({ isOpenModal: !this.state.isOpenModal });
  };

  render() {
    let {
      vip_price,
      trade_percent_commission,
      vip_percent_commission,
      window_width,
      asset_affiliate_network_banner,
    } = this.props.appReducer;
    let {
      is_show_buy,
      agree_vip,
      duty_vip,
      selected_tab,
      trade_commission,
      vip_commission,
      vip_data,
      commission,
    } = this.state;
    let { user_mode, username, ref_username, ref_code, vip } =
      this.props.memberReducer;
    const { t } = this.props;
    let monthVolumne = Object.entries(vip_data?.volume_month || []);
    return (
      <div data-v-b0e45e8c="" id="mainContent">
        {user_mode !== "unlimited" && (
          <div
            style={{
              backgroundImage: `url("images/affiliate_wait_bg.png")`,
              backgroundSize: "cover",
            }}
          >
            <div
              className="row flex align-items-center limited-content "
              style={{
                maxWidth: "1110px",
                margin: "0 auto",
                padding: "40px 10px 40px 10px",
              }}
            >
              <div data-v-22dfce66="" className="col-lg-6 col-12">
                <p
                  data-v-22dfce66=""
                  className="font-30 font-18m font-weight-700 color-white line-height-normal mb-4"
                >
                  {t("MemberVip")}
                </p>
                <button
                  data-v-22dfce66=""
                  type="button"
                  onClick={this.onClickModel("is_show_buy")}
                  className="btn button wbtn btn-green btn-large"
                >
                  {t("BuyNow")} ${formatNumber(vip_price)}
                </button>
              </div>
              <div
                data-v-22dfce66=""
                className=" col-lg-6 col-12"
                style={{
                  backgroundColor: "#181a20",
                  padding: "20px 20px 40px 20px",
                  // border: "1px solid #00C67A",
                  margin: "0",
                  borderRadius: "20px",
                }}
              >
                <div
                  data-v-d201240a=""
                  data-v-22dfce66=""
                  className="register-link"
                >
                  {" "}
                  <label data-v-d201240a="">Link đăng ký</label>
                  <div data-v-d201240a="" className="groupButton d-flex">
                    <div data-v-d201240a="" className="leftControl">
                      <input
                        data-v-d201240a=""
                        type="text"
                        readOnly="readonly"
                        value={getUrl("register?r=" + ref_code)}
                        className="form-control w-100 font-14"
                      />
                    </div>
                    <div data-v-d201240a="" className="rightControl">
                      <button
                        data-v-d201240a=""
                        onClick={this.onCopy}
                        className="btn"
                      >
                        {t("Copy")}
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  data-v-d201240a=""
                  data-v-22dfce66=""
                  className="register-link mt-lg-3"
                >
                  {" "}
                  <label data-v-d201240a="">{t("ReferralCode")}</label>
                  <div data-v-d201240a="" className="groupButton d-flex w-50">
                    <div data-v-d201240a="" className="leftControl">
                      <input
                        data-v-d201240a=""
                        type="text"
                        readOnly="readonly"
                        value={ref_code || "NOCODE"}
                        className="form-control w-100 font-14"
                      />
                    </div>
                    <div data-v-d201240a="" className="rightControl">
                      <button
                        data-v-d201240a=""
                        onClick={this.onCopy2}
                        className="btn"
                      >
                        {t("Copy")}
                        {/* <img
																				data-v-d201240a=""
																				src="data:image/svg+xml;base64,PHN2ZyBpZD0iaWNfY29udGVudF9jb3B5XzQ4cHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEzLjE0NiIgaGVpZ2h0PSIxNS4yMjEiIHZpZXdCb3g9IjAgMCAxMy4xNDYgMTUuMjIxIj4KICA8cGF0aCBpZD0iUGF0aF8zNjIyNSIgZGF0YS1uYW1lPSJQYXRoIDM2MjI1IiBkPSJNMTMuNjg2LDJoLTguM0ExLjM4MywxLjM4MywwLDAsMCw0LDMuMzg0VjEzLjA3SDUuMzg0VjMuMzg0aDguM1ptMi4wNzYsMi43NjhIOC4xNTFBMS4zODMsMS4zODMsMCwwLDAsNi43NjgsNi4xNTF2OS42ODZhMS4zODMsMS4zODMsMCwwLDAsMS4zODQsMS4zODRoNy42MTFhMS4zODMsMS4zODMsMCwwLDAsMS4zODQtMS4zODRWNi4xNTFBMS4zODMsMS4zODMsMCwwLDAsMTUuNzYyLDQuNzY4Wm0wLDExLjA3SDguMTUxVjYuMTUxaDcuNjExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQgLTIpIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo=" /> */}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-v-22dfce66=""
              className="subBanner d-flex align-items-center position-fixed"
              style={{
                width: "100%",
                height: "120px",
                background: "#181a20",
                bottom: 0,
              }}
            >
              <div
                data-v-14142db8=""
                data-v-22dfce66=""
                className="container text-white subaner-content-warpper"
              >
                <div
                  data-v-14142db8=""
                  className="subaner-content row align-items-center"
                >
                  <div data-v-14142db8="" className="col">
                    <div
                      data-v-14142db8=""
                      className="d-flex boxContent h-100 align-items-center"
                    >
                      <div
                        data-v-14142db8=""
                        className="d-flex align-items-center"
                      >
                        <div data-v-14142db8="">
                          <div data-v-14142db8="" className="icon iconInvite" />
                        </div>
                        <div data-v-14142db8="">
                          <div data-v-14142db8="" className="textContent">
                            <p
                              data-v-14142db8=""
                              className="mb-1"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {t("InviteFriend")}
                            </p>{" "}
                            <p
                              data-v-14142db8=""
                              className="color-white-50 mb-0"
                            >
                              {t("InviteFriendRegister")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-14142db8="" className="borderSubBanner" />
                  <div data-v-14142db8="" className="col">
                    <div
                      data-v-14142db8=""
                      className="d-flex boxContent h-100 align-items-center"
                    >
                      <div
                        data-v-14142db8=""
                        className="d-flex align-items-center"
                      >
                        <div data-v-14142db8="">
                          <div data-v-14142db8="" className="icon iconSign" />
                        </div>
                        <div data-v-14142db8="">
                          <div data-v-14142db8="" className="textContent">
                            <p
                              data-v-14142db8=""
                              className="mb-1"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {t("FriendRegistered")}
                            </p>{" "}
                            <p
                              data-v-14142db8=""
                              className="color-white-50 mb-0"
                            >
                              {t("FriendAccepted")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-14142db8="" className="borderSubBanner" />
                  <div data-v-14142db8="" className="col">
                    <div
                      data-v-14142db8=""
                      className="d-flex boxContent h-100 align-items-center"
                    >
                      <div
                        data-v-14142db8=""
                        className="d-flex align-items-center"
                      >
                        <div data-v-14142db8="">
                          <div
                            data-v-14142db8=""
                            className="icon iconCommission"
                          />
                        </div>
                        <div data-v-14142db8="">
                          <div data-v-14142db8="" className="textContent">
                            <p
                              data-v-14142db8=""
                              className="mb-1"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {t("CommissionShare")}
                            </p>{" "}
                            <p
                              data-v-14142db8=""
                              className="color-white-50 mb-0"
                            >
                              {t("CommissionEasy")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-v-36903699="" data-v-22dfce66="" className="authPopup">
              <div
                data-v-36903699=""
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
                style={{ display: is_show_buy ? "block" : "none" }}
                className={setClassNameCondition(
                  is_show_buy,
                  "show",
                  "",
                  "modal fade modalBuyNow"
                )}
              >
                <div data-v-36903699="" className="modal-dialog modal-auth">
                  <div
                    data-v-36903699=""
                    onClick={this.onClickModel("is_show_buy")}
                    className="close-page"
                  >
                    <span data-v-36903699="" className="pe pe-7s-close" />
                  </div>
                  <div data-v-36903699="" className="modal-content aff">
                    <div className="loading">
                      <div className="loading__ring">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 100 100"
                          style={{ enableBackground: "new 0 0 100 100" }}
                          xmlSpace="preserve"
                        >
                          <path d="M85.5,42c-0.2-0.8-0.5-1.7-0.8-2.5c-0.3-0.9-0.7-1.6-1-2.3c-0.3-0.7-0.6-1.3-1-1.9c0.3,0.5,0.5,1.1,0.8,1.7  c0.2,0.7,0.6,1.5,0.8,2.3s0.5,1.7,0.8,2.5c0.8,3.5,1.3,7.5,0.8,12c-0.4,4.3-1.8,9-4.2,13.4c-2.4,4.2-5.9,8.2-10.5,11.2  c-1.1,0.7-2.2,1.5-3.4,2c-0.5,0.2-1.2,0.6-1.8,0.8s-1.3,0.5-1.9,0.8c-2.6,1-5.3,1.7-8.1,1.8l-1.1,0.1L53.8,84c-0.7,0-1.4,0-2.1,0  c-1.4-0.1-2.9-0.1-4.2-0.5c-1.4-0.1-2.8-0.6-4.1-0.8c-1.4-0.5-2.7-0.9-3.9-1.5c-1.2-0.6-2.4-1.2-3.7-1.9c-0.6-0.3-1.2-0.7-1.7-1.1  l-0.8-0.6c-0.3-0.1-0.6-0.4-0.8-0.6l-0.8-0.6L31.3,76l-0.2-0.2L31,75.7l-0.1-0.1l0,0l-1.5-1.5c-1.2-1-1.9-2.1-2.7-3.1  c-0.4-0.4-0.7-1.1-1.1-1.7l-1.1-1.7c-0.3-0.6-0.6-1.2-0.9-1.8c-0.2-0.5-0.6-1.2-0.8-1.8c-0.4-1.2-1-2.4-1.2-3.7  c-0.2-0.6-0.4-1.2-0.5-1.9c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3-1.2-0.3-2.4-0.4-3.7c-0.1-1.2,0-2.5,0.1-3.7c0.2-1.2,0.3-2.4,0.6-3.5  c0.1-0.6,0.3-1.1,0.4-1.7l0.1-0.8l0.3-0.8c1.5-4.3,3.8-8,6.5-11c0.8-0.8,1.4-1.5,2.1-2.1c0.9-0.9,1.4-1.3,2.2-1.8  c1.4-1.2,2.9-2,4.3-2.8c2.8-1.5,5.5-2.3,7.7-2.8s4-0.7,5.2-0.6c0.6-0.1,1.1,0,1.4,0s0.4,0,0.4,0h0.1c2.7,0.1,5-2.2,5-5  c0.1-2.7-2.2-5-5-5c-0.2,0-0.2,0-0.3,0c0,0-0.2,0.1-0.6,0.1c-0.4,0-1,0-1.8,0.1c-1.6,0.1-4,0.4-6.9,1.2c-2.9,0.8-6.4,2-9.9,4.1  c-1.8,1-3.6,2.3-5.4,3.8C26,21.4,25,22.2,24.4,23c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.6,0.7c-0.5,0.4-0.8,0.9-1.3,1.4  c-3.2,3.9-5.9,8.8-7.5,14.3l-0.3,1l-0.2,1.1c-0.1,0.7-0.3,1.4-0.4,2.1c-0.3,1.5-0.4,2.9-0.5,4.5c0,1.5-0.1,3,0.1,4.5  c0.2,1.5,0.2,3,0.6,4.6c0.1,0.7,0.3,1.5,0.4,2.3c0.2,0.8,0.5,1.5,0.7,2.3c0.4,1.6,1.1,3,1.7,4.4c0.3,0.7,0.7,1.4,1.1,2.1  c0.4,0.8,0.8,1.4,1.2,2.1c0.5,0.7,0.9,1.4,1.4,2s0.9,1.3,1.5,1.9c1.1,1.3,2.2,2.7,3.3,3.5l1.7,1.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0,0,0,0l0.1,0.1l0.1,0.1h0.2l0.5,0.4l1,0.7c0.4,0.2,0.6,0.5,1,0.7l1.1,0.6c0.8,0.4,1.4,0.9,2.1,1.2c1.4,0.7,2.9,1.5,4.4,2  c1.5,0.7,3.1,1,4.6,1.5c1.5,0.3,3.1,0.7,4.7,0.8c1.6,0.2,3.1,0.2,4.7,0.2c0.8,0,1.6-0.1,2.4-0.1l1.2-0.1l1.1-0.1  c3.1-0.4,6.1-1.3,8.9-2.4c0.8-0.3,1.4-0.6,2.1-0.9s1.3-0.7,2-1.1c1.3-0.7,2.6-1.7,3.7-2.5c0.5-0.4,1-0.9,1.6-1.3l0.8-0.6l0.2-0.2  c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0,0,0,0v0.1l0.1-0.1l0.4-0.4c0.5-0.5,1-1,1.5-1.5c0.3-0.3,0.5-0.5,0.8-0.8l0.7-0.8  c0.9-1.1,1.8-2.2,2.5-3.3c0.4-0.6,0.7-1.1,1.1-1.7c0.3-0.7,0.6-1.2,0.9-1.8c2.4-4.9,3.5-9.8,3.7-14.4C87.3,49.7,86.6,45.5,85.5,42z" />
                        </svg>
                      </div>
                      <div className="loading__ring">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 100 100"
                          style={{ enableBackground: "new 0 0 100 100" }}
                          xmlSpace="preserve"
                        >
                          <path d="M85.5,42c-0.2-0.8-0.5-1.7-0.8-2.5c-0.3-0.9-0.7-1.6-1-2.3c-0.3-0.7-0.6-1.3-1-1.9c0.3,0.5,0.5,1.1,0.8,1.7  c0.2,0.7,0.6,1.5,0.8,2.3s0.5,1.7,0.8,2.5c0.8,3.5,1.3,7.5,0.8,12c-0.4,4.3-1.8,9-4.2,13.4c-2.4,4.2-5.9,8.2-10.5,11.2  c-1.1,0.7-2.2,1.5-3.4,2c-0.5,0.2-1.2,0.6-1.8,0.8s-1.3,0.5-1.9,0.8c-2.6,1-5.3,1.7-8.1,1.8l-1.1,0.1L53.8,84c-0.7,0-1.4,0-2.1,0  c-1.4-0.1-2.9-0.1-4.2-0.5c-1.4-0.1-2.8-0.6-4.1-0.8c-1.4-0.5-2.7-0.9-3.9-1.5c-1.2-0.6-2.4-1.2-3.7-1.9c-0.6-0.3-1.2-0.7-1.7-1.1  l-0.8-0.6c-0.3-0.1-0.6-0.4-0.8-0.6l-0.8-0.6L31.3,76l-0.2-0.2L31,75.7l-0.1-0.1l0,0l-1.5-1.5c-1.2-1-1.9-2.1-2.7-3.1  c-0.4-0.4-0.7-1.1-1.1-1.7l-1.1-1.7c-0.3-0.6-0.6-1.2-0.9-1.8c-0.2-0.5-0.6-1.2-0.8-1.8c-0.4-1.2-1-2.4-1.2-3.7  c-0.2-0.6-0.4-1.2-0.5-1.9c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3-1.2-0.3-2.4-0.4-3.7c-0.1-1.2,0-2.5,0.1-3.7c0.2-1.2,0.3-2.4,0.6-3.5  c0.1-0.6,0.3-1.1,0.4-1.7l0.1-0.8l0.3-0.8c1.5-4.3,3.8-8,6.5-11c0.8-0.8,1.4-1.5,2.1-2.1c0.9-0.9,1.4-1.3,2.2-1.8  c1.4-1.2,2.9-2,4.3-2.8c2.8-1.5,5.5-2.3,7.7-2.8s4-0.7,5.2-0.6c0.6-0.1,1.1,0,1.4,0s0.4,0,0.4,0h0.1c2.7,0.1,5-2.2,5-5  c0.1-2.7-2.2-5-5-5c-0.2,0-0.2,0-0.3,0c0,0-0.2,0.1-0.6,0.1c-0.4,0-1,0-1.8,0.1c-1.6,0.1-4,0.4-6.9,1.2c-2.9,0.8-6.4,2-9.9,4.1  c-1.8,1-3.6,2.3-5.4,3.8C26,21.4,25,22.2,24.4,23c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.6,0.7c-0.5,0.4-0.8,0.9-1.3,1.4  c-3.2,3.9-5.9,8.8-7.5,14.3l-0.3,1l-0.2,1.1c-0.1,0.7-0.3,1.4-0.4,2.1c-0.3,1.5-0.4,2.9-0.5,4.5c0,1.5-0.1,3,0.1,4.5  c0.2,1.5,0.2,3,0.6,4.6c0.1,0.7,0.3,1.5,0.4,2.3c0.2,0.8,0.5,1.5,0.7,2.3c0.4,1.6,1.1,3,1.7,4.4c0.3,0.7,0.7,1.4,1.1,2.1  c0.4,0.8,0.8,1.4,1.2,2.1c0.5,0.7,0.9,1.4,1.4,2s0.9,1.3,1.5,1.9c1.1,1.3,2.2,2.7,3.3,3.5l1.7,1.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0,0,0,0l0.1,0.1l0.1,0.1h0.2l0.5,0.4l1,0.7c0.4,0.2,0.6,0.5,1,0.7l1.1,0.6c0.8,0.4,1.4,0.9,2.1,1.2c1.4,0.7,2.9,1.5,4.4,2  c1.5,0.7,3.1,1,4.6,1.5c1.5,0.3,3.1,0.7,4.7,0.8c1.6,0.2,3.1,0.2,4.7,0.2c0.8,0,1.6-0.1,2.4-0.1l1.2-0.1l1.1-0.1  c3.1-0.4,6.1-1.3,8.9-2.4c0.8-0.3,1.4-0.6,2.1-0.9s1.3-0.7,2-1.1c1.3-0.7,2.6-1.7,3.7-2.5c0.5-0.4,1-0.9,1.6-1.3l0.8-0.6l0.2-0.2  c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0,0,0,0v0.1l0.1-0.1l0.4-0.4c0.5-0.5,1-1,1.5-1.5c0.3-0.3,0.5-0.5,0.8-0.8l0.7-0.8  c0.9-1.1,1.8-2.2,2.5-3.3c0.4-0.6,0.7-1.1,1.1-1.7c0.3-0.7,0.6-1.2,0.9-1.8c2.4-4.9,3.5-9.8,3.7-14.4C87.3,49.7,86.6,45.5,85.5,42z" />
                        </svg>
                      </div>
                    </div>
                    <div data-v-36903699="" className="contentWrapper">
                      <div data-v-36903699="" className="header">
                        <span
                          data-v-36903699=""
                          className="font-20 font-weight-700 text-capitalize"
                        >
                          {t("AcceptParticipation")}
                        </span>
                      </div>
                      <div data-v-36903699="" className="body">
                        <div data-v-36903699="" className="imgShake mb-3" />
                        <div data-v-36903699="" className="textContent mb-3">
                          {t("YouNeedToPay.1")} <b>${formatNumber(vip_price)}</b>{" "}
                          {t("YouNeedToPay.2")}
                        </div>
                        <div
                          data-v-36903699=""
                          className="checkbox d-flex justify-content-center"
                        >
                          <input
                            onChange={this.onChangeAgreeVip}
                            data-v-36903699=""
                            type="checkbox"
                            checked={agree_vip}
                            id="customControlInline"
                            className="checkboxInput"
                          />
                          <span
                            data-v-36903699=""
                            htmlFor="customControlInline"
                          >
                            {t("AcknowledgeAndAgree")}
                            <span data-v-36903699="" className="text-primary-custom">
                              {" "}
                              {t("TermsOfService")}
                            </span>
                          </span>
                        </div>
                        <div
                          data-v-36903699=""
                          className="checkbox d-flex justify-content-center"
                        >
                          <input
                            onChange={this.onChangeDutyVip}
                            data-v-36903699=""
                            type="checkbox"
                            checked={duty_vip}
                            id="customControlInline"
                            className="checkboxInput"
                          />
                          <span
                            data-v-36903699=""
                            htmlFor="customControlInline"
                          >
                            {t("AcknowledgeAndAgree")}
                            <span data-v-36903699="" className="text-primary-custom">
                              {" "}
                              {t("VipDuty")}
                            </span>
                          </span>
                        </div>
                        <button
                          data-v-36903699=""
                          disabled={!duty_vip}
                          onClick={this.onBuyVip}
                          className="btn button wbtn btn-large btn-radius w-100 font-weight-700"
                        >
                          Xác nhận
                        </button>
                        <p data-v-36903699="" className="textError" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {user_mode === "unlimited" && (
          <div
            data-v-b0e45e8c=""
            style={{
              height: "100%",
              background: "#181A20",
              backgroundSize: "cover",
            }}
          >
            <div
              style={{
                display: `${this.state.isOpenModal ? "block" : "none"}`,
              }}
            >
              <div
                style={{
                  background: "black",
                  position: "fixed",
                  inset: 0,
                  zIndex: "1200",
                  opacity: 0.5,
                }}
              ></div>
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-80%)",
                  zIndex: "1300",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgb(230, 230, 230, 0.2)",
                    fontSize: "20px",
                    borderRadius: "50%",
                    position: "absolute",
                    right: 0,
                    top: 0,
                    transform: "translate(100%, -100% )",
                    cursor: "pointer",
                  }}
                  onClick={this.handleToggleModal}
                >
                  <i className="fas fa-xmark"></i>
                </div>
                <div
                  style={{
                    width: `${isDesktop() ? "40vw" : "80vw"}`,
                  }}
                >
                  <img src="/images/aff_rank.png" alt="" />
                </div>
              </div>
            </div>
            <div className="community">
              <div data-v-46bc7c21="" data-v-b0e45e8c="" className="page">
                <div
                  data-v-5884b68b=""
                  data-v-46bc7c21=""
                  // className="backgroundDark"
                  style={{
                    backgroundColor: "#1D233B",
                  }}
                >
                  <div
                    data-v-5884b68b=""
                    className="container"
                    style={{
                      padding: "0 12px",
                    }}
                  >
                    <ul
                      data-v-5884b68b=""
                      id="pills-tab"
                      role="tablist"
                      className="nav nav-pills flex-nowrap menuHeaderLink "
                    >
                      <li
                        data-v-5884b68b=""
                        id="community"
                        className="nav-item"
                      >
                        <a
                          data-v-5884b68b=""
                          href="#"
                          onClick={this.onSelectTab("general")}
                          className={setClassNameCondition(
                            selected_tab === "general",
                            "router-link-exact-active router-link-active",
                            "",
                            "nav-link"
                          )}
                          style={{
                            padding: "0 14px",
                            lineHeight: "50px",
                            fontSize: "15px",
                            marginTop: "6px",
                          }}
                        >
                          {t("Overview")}
                        </a>
                      </li>
                      <li
                        data-v-5884b68b=""
                        id="portfolio"
                        className="nav-item"
                      >
                        <a
                          data-v-5884b68b=""
                          href="#"
                          onClick={this.onSelectTab("commission")}
                          className={setClassNameCondition(
                            selected_tab === "commission",
                            "router-link-exact-active router-link-active",
                            "",
                            "nav-link"
                          )}
                          style={{
                            padding: "0 14px",
                            lineHeight: "50px",
                            fontSize: "15px",
                            marginTop: "6px",
                          }}
                        >
                          {t("Commission")}
                        </a>
                      </li>
                      <li
                        data-v-5884b68b=""
                        id="expertArea"
                        className="nav-item"
                      >
                        <a
                          data-v-5884b68b=""
                          href="#"
                          onClick={this.onSelectTab("network")}
                          className={setClassNameCondition(
                            selected_tab === "network",
                            "router-link-exact-active router-link-active",
                            "",
                            "nav-link"
                          )}
                          style={{
                            padding: "0 14px",
                            lineHeight: "50px",
                            fontSize: "15px",
                            marginTop: "6px",
                          }}
                        >
                          {t("SystemManagement")}
                        </a>
                      </li>
                      <li
                        data-v-5884b68b=""
                        id="expertArea"
                        className="nav-item"
                      >
                        <a
                          data-v-5884b68b=""
                          href="#"
                          onClick={this.onSelectTab("upgrade")}
                          className={setClassNameCondition(
                            selected_tab === "upgrade",
                            "router-link-exact-active router-link-active",
                            "",
                            "nav-link"
                          )}
                          style={{
                            padding: "0 14px",
                            lineHeight: "50px",
                            fontSize: "15px",
                            marginTop: "6px",
                          }}
                        >
                          {t("Upgrade")} VIP
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {selected_tab === "general" && (
                  <div
                    style={{
                      padding: "0px 28px",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "1185px",
                        margin: "30px auto",
                      }}
                    >
                      <div
                        className="row text-white"
                        style={{
                          columnGap: "15px",
                          rowGap: "25px",
                          marginBottom: "25px",
                        }}
                      >
                        <div
                          className="col-12 col-lg"
                          style={{
                            borderRadius: "20px",
                            padding: "40px 20px 0px 20px",
                            backgroundColor: "transparent",
                            border: "1px solid #303539",
                            minHeight: "263px",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              className="border border-warning rounded-lg d-flex align-items-center justify-content-center text-warning position-relative"
                              style={{
                                width: "155px",
                                height: "45px",
                                borderRadius: "14px",
                                marginLeft: "40px",
                                userSelect: "none",
                                cursor: "pointer",
                              }}
                              onClick={this.handleToggleModal}
                            >
                              <div
                                className="m-0 text-warning"
                                style={{
                                  fontSize: "13px",
                                  paddingLeft: "20px",
                                }}
                              >
                                {t("Rank")}
                              </div>
                              <div
                                className="ml-2 border d-flex align-items-center border-warning justify-content-center rounded-circle"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  fontSize: "12px",
                                }}
                              >
                                <div className="text-warning">?</div>
                              </div>
                              <div
                                className="position-absolute "
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  backgroundImage: `url(${this.getRankIconForUser(
                                    this.state.userRanking
                                  )})`,
                                  backgroundPosition: "center",
                                  backgroundSize: "cover",
                                  left: 0,
                                  transform: "translateX(-50%)",
                                }}
                              ></div>
                            </div>
                            {this.state.userRanking === "rank7" && (
                              <div
                                className="ml-2 d-flex align-items-center border border-warning text-warning justify-content-center font-weight-bold"
                                style={{
                                  width: "57px",
                                  height: "36px",
                                  borderRadius: "10px",
                                  opacity: "0.6",
                                  backgroundColor: "#82f92a1f",
                                  fontSize: "10px",
                                }}
                              >
                                Max Lv
                              </div>
                            )}
                            {this.state.userRanking !== "rank7" && (
                              <div
                                className="ml-2 d-flex align-items-center border border-warning text-warning justify-content-center font-weight-bold"
                                style={{
                                  width: "max-content",
                                  height: "36px",
                                  padding: "0px 10px",
                                  borderRadius: "10px",
                                  backgroundColor: "#82f92a1f",
                                  fontSize: "10px",
                                }}
                              >
                                <i className="fas fa-up-long"></i>
                                <span
                                  className="ml-1"
                                  onClick={() => {
                                    this.setState({ selected_tab: "upgrade" });
                                  }}
                                  style={{
                                    userSelect: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  Upgrade lv
                                </span>
                              </div>
                            )}
                          </div>
                          <hr
                            style={{
                              marginTop: "36px",
                              backgroundColor: "#303539",
                            }}
                          />
                          <h5
                            className=""
                            style={{
                              fontSize: "20px",
                              marginBottom: "16px",
                            }}
                          >
                            {t("Condition")} {t("Rank")}
                          </h5>
                          <div
                            className="row"
                            style={{
                              color: "#5d606c",
                              fontSize: "14px",
                              marginBottom: "10px",
                              rowGap: "10px",
                            }}
                          >
                            <div className="col-md-6 col-12">
                              <p style={{ color: "#5d606c" }}>F1 {t("Total")} ({t("Week")})</p>
                              <p
                                style={{
                                  fontSize: "18px",
                                  marginTop: "10px",
                                }}
                              >
                                {/* <span style={{ color: "white" }}>
                                  {Math.ceil(
                                    Number(vip_data?.volume_week) || 0
                                  ).toLocaleString("en-US")}
                                </span>
                                /{" "}
                                <span style={{ color: "#5d606c" }}>
                                  {vip_data?.f1_max_volume.toLocaleString(
                                    "en-US"
                                  ) || 0}
                                </span> */}
                                <span style={{ color: "white" }}>
                                  {Math.ceil(Number(vip_data?.volume_week) || 0) > Number(vip_data?.f1_max_volume || 0)
                                    ? Number(vip_data?.f1_max_volume || 0).toLocaleString("en-US")
                                    : Math.ceil(Number(vip_data?.volume_week) || 0).toLocaleString("en-US")}
                                </span>
                                /{" "}
                                <span style={{ color: "#5d606c" }}>
                                  {Number(vip_data?.f1_max_volume || 0).toLocaleString("en-US") || 0}
                                </span>
                              </p>
                            </div>
                            <div
                              className="col-md-6 col-12"
                              style={{
                                color: "#5d606c",
                              }}
                            >
                              F1 Vip
                              <p
                                style={{
                                  fontSize: "18px",
                                  marginTop: "10px",
                                }}
                              >
                                <span style={{ color: "white" }}>
                                  {vip_data?.f1membersVip || 0}
                                </span>
                                /{" "}
                                <span
                                  style={{
                                    color: "#5d606c",
                                  }}
                                >
                                  {vip_data?.f1_max_vip || 0}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12 col-lg"
                          style={{
                            borderRadius: "20px",
                            padding: "40px 20px 0px 20px",
                            backgroundColor: "transparent",
                            border: "1px solid #303539",
                            height: "263px",
                          }}
                        >
                          <p>
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#5d606c",
                              }}
                            >
                              {t("Presenter")}
                            </span>{" "}
                            <span>{ref_username || "***"}</span>
                          </p>
                          <hr style={{ background: "#303539" }} />
                          <div
                            className="row"
                            style={{
                              height: "68px",
                              marginBottom: "8px",
                            }}
                          >
                            <div
                              className="col-6"
                              style={{
                                fontSize: "12px",
                                color: "#5d606c",
                              }}
                            >
                              <p style={{ color: "#5d606c" }}>
                                {t("TotalNumberOfTraders")}
                              </p>
                              <p
                                className=""
                                style={{
                                  color: "#04c793",
                                  fontSize: "20px",
                                }}
                              >
                                {vip_data?.totalMemberTrade || 0}
                              </p>
                            </div>
                            <div
                              className="col-6"
                              style={{
                                fontSize: "12px",
                                color: "#5d606c",
                              }}
                            >
                              <p style={{ color: "#5d606c" }}>
                                {t("TotalOfVipMembers")}
                              </p>
                              <p
                                style={{
                                  color: "#00b6ff",
                                  fontSize: "20px",
                                }}
                              >
                                {vip_data?.totalFmembersVip || 0}
                              </p>
                            </div>
                          </div>
                          <div className="row" style={{ height: "68px" }}>
                            <div
                              className="col-6"
                              style={{
                                fontSize: "12px",
                                color: "#5d606c",
                              }}
                            >
                              <p style={{ color: "#5d606c" }}>
                                {t("TradingCommissions")}
                              </p>
                              <p
                                style={{
                                  color: "#fa4b62",
                                  fontSize: "20px",
                                }}
                              >
                                {/* {Number(vip_data?.commission_percent || 0)} */}
                                {Number(vip_data?.commission_percent || 0).toLocaleString("en-US")}
                              </p>
                            </div>
                            <div
                              className="col-6"
                              style={{
                                fontSize: "12px",
                                color: "#5d606c",
                              }}
                            >
                              <p style={{ color: "#5d606c" }}>
                                {t("VipMemberCommissions")}
                              </p>
                              <p
                                style={{
                                  color: "#af40fe",
                                  fontSize: "20px",
                                }}
                              >
                                {/* {Number(
                                  vip_data?.vipPercent || 0
                                )} */}
                                {Number(vip_data?.vipPercent || 0).toLocaleString("en-US")}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12 col-lg"
                          style={{
                            borderRadius: "20px",
                            padding: "40px 20px 0px 20px",
                            backgroundColor: "transparent",
                            border: "1px solid #303539",
                            height: "263px",
                          }}
                        >
                          <div
                            data-v-d201240a=""
                            data-v-22dfce66=""
                            className="register-link"
                          >
                            {" "}
                            <label
                              data-v-d201240a=""
                              style={{
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "bold",
                                marginBottom: "15px",
                              }}
                            >
                              <span
                                className="mr-2"
                                style={{ color: "#3dc99f" }}
                              >
                                <i className="fas fa-link"></i>
                              </span>
                              {t("LinkRegister")}
                            </label>
                            <div
                              data-v-d201240a=""
                              className="groupButton d-flex"
                            >
                              <div data-v-d201240a="" className="leftControl">
                                <input
                                  data-v-d201240a=""
                                  type="text"
                                  readOnly="readonly"
                                  value={getUrl("register?r=" + ref_code)}
                                  className="form-control w-100 font-14"
                                />
                              </div>
                              <div data-v-d201240a="" className="rightControl">
                                <button
                                  data-v-d201240a=""
                                  onClick={this.onCopy}
                                  className="btn"
                                  style={{
                                    background: "#3dc99f",
                                    backgroundImage:
                                      "linear-gradient(#3dc99f, white) !important",
                                    cursor: "pointer",
                                  }}
                                >
                                  {t("Copy")}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            data-v-d201240a=""
                            data-v-22dfce66=""
                            className="register-link mt-lg-3 mt-5"
                          >
                            {" "}
                            <label
                              data-v-d201240a=""
                              style={{
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "bold",
                                marginBottom: "15px",
                              }}
                            >
                              <span
                                className="mr-2"
                                style={{
                                  color: "#3dc99f",
                                }}
                              >
                                <i className="fas fa-link"></i>
                              </span>
                              {t("ReferralCode")}
                            </label>
                            <div
                              data-v-d201240a=""
                              className="groupButton d-flex"
                            >
                              <div data-v-d201240a="" className="leftControl">
                                <input
                                  data-v-d201240a=""
                                  type="text"
                                  readOnly="readonly"
                                  value={ref_code || "NOCODE"}
                                  className="form-control w-100 font-14"
                                />
                              </div>
                              <div data-v-d201240a="" className="rightControl">
                                <button
                                  data-v-d201240a=""
                                  onClick={this.onCopy}
                                  className="btn"
                                  style={{
                                    background: "#3dc99f",
                                    cursor: "pointer",
                                  }}
                                >
                                  {t("Copy")}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Số liệu */}
                      <div
                        className="row text-white"
                        style={{
                          columnGap: "10px",
                          rowGap: "25px",
                        }}
                      >
                        <div
                          className="col-12 col-xl-8"
                          style={{
                            minHeight: "306px",
                            borderRadius: "20px",
                            padding: 0,
                          }}
                        >
                          <div
                            style={{
                              padding: "0px 32px",
                              border: "1px solid #303539",
                              borderRadius: "20px 20px 0px 0px",
                              backgroundColor: "transparent",
                            }}
                          >
                            <ul
                              data-v-5884b68b=""
                              id="pills-tab"
                              role="tablist"
                              className="nav nav-pills menuHeaderLink"
                              style={{ gap: "20px" }}
                            >
                              <li
                                data-v-5884b68b=""
                                id="community"
                                className="nav-item d-flex align-items-center"
                              >
                                <div
                                  onClick={() => {
                                    this.handleSelectMonthTab("current");
                                  }}
                                  className={setClassNameCondition(
                                    this.state.monthTab === "current",
                                    "router-link-exact-active router-link-active",
                                    "",
                                    "nav-link"
                                  )}
                                  style={{
                                    padding: "0",
                                    lineHeight: "50px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {t("ThisMonth")}
                                </div>
                              </li>
                              <li
                                data-v-5884b68b=""
                                id="portfolio"
                                className="nav-item "
                              >
                                <div
                                  onClick={() => {
                                    this.handleSelectMonthTab("prevMonth");
                                  }}
                                  className={setClassNameCondition(
                                    this.state.monthTab === "prevMonth",
                                    "router-link-exact-active router-link-active",
                                    "",
                                    "nav-link"
                                  )}
                                  style={{
                                    padding: "0",
                                    lineHeight: "50px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                >
                                  {t("LastMonth")}
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div
                            style={{
                              minHeight: "257px",
                              padding: "16px 20px",
                              border: "1px solid #303539",
                              borderTopColor: "transparent",
                              borderRadius: "0px 0px 20px 20px",
                              backgroundColor: "transparent",
                            }}
                          >
                            <div className="row">
                              <div
                                className=" col-12 col-md-4"
                                style={{
                                  marginTop: "24px",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "700",
                                    marginBottom: "24px",
                                  }}
                                >
                                  {t("RecentFigures")}
                                </p>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    color: "#04c793",
                                    marginBottom: "24px",
                                  }}
                                >
                                  {t("TotalNumberOfTraders")} {t("New")} (
                                  {this.state.monthTab === "current" &&
                                    (Object.values(
                                      vip_data?.totalMemberTradeCurrentMonth ||
                                      0
                                    ).pop() ||
                                      0)}
                                  {this.state.monthTab === "prevMonth" &&
                                    (Object.values(
                                      vip_data?.totalMemberTradeLastMonth || 0
                                    ).pop() ||
                                      0)}
                                  )
                                </p>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    color: "#00b6ff",
                                    marginBottom: "24px",
                                  }}
                                >
                                  {t("TotalOfVipMembers")} (
                                  {this.state.monthTab === "current" &&
                                    (Object.values(
                                      vip_data?.totalVipCurrentMonth || 0
                                    ).pop() ||
                                      0)}
                                  {this.state.monthTab === "prevMonth" &&
                                    (Object.values(
                                      vip_data?.totalVipLastMonth || 0
                                    ).pop() ||
                                      0)}
                                  )
                                </p>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    color: "#fa4b62",
                                    marginBottom: "24px",
                                  }}
                                >
                                  {t("TotalNewCommissions")} (
                                  {this.state.monthTab === "current" &&
                                    Number(
                                      Object.values(
                                        vip_data?.totalCommissionCurrentMonth ||
                                        0
                                      ).pop() || 0
                                    ).toFixed(2)}
                                  {this.state.monthTab === "prevMonth" &&
                                    Number(
                                      Object.values(
                                        vip_data?.totalCommissionLastMonth || 0
                                      ).pop() || 0
                                    ).toFixed(2)}
                                  )
                                </p>
                              </div>
                              <div className="col-12 col-md-8 chart-wrapper">
                                <HighchartsReact
                                  ref={this.chartRef}
                                  highcharts={Highcharts}
                                  options={this.state.chartOptions}
                                  containerProps={{
                                    style: {
                                      width: "100%",
                                      height: "100%",
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="position-relative col-12 col-md"
                          style={{
                            minHeight: "310px",
                            border: "1px solid #303539",
                            borderRadius: "20px",
                            backgroundColor: "transparent",
                            padding: "16px 10px 0px 10px",
                          }}
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{
                              gap: "8px",
                              marginBottom: "16px",
                            }}
                          >
                            <i className="fas fa-chart-simple"></i>
                            <p
                              className="m-0"
                              style={{
                                fontSize: "20px",
                                fontWeight: "700",
                              }}
                            >
                              <i
                                className="fas fa-chart-bar"
                                style={{
                                  marginRight: "10px",
                                  color: "#3dc99f",
                                }}
                              ></i>
                              {t("LowerLevelTradingVolume")}
                            </p>{" "}
                            <div
                              className="tt-wrapper"
                              onClick={() => {
                                this.setState({
                                  is_show_tooltip: !this.state.is_show_tooltip,
                                });
                              }}
                            >
                              <div
                                className="d-flex justify-content-center align-items-center rounded-circle"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  border: "1px solid #3dc99f",
                                  borderRadius: "99px",
                                  fontSize: "12px",
                                  color: "#3dc99f",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fas fa-question"></i>
                              </div>
                              <div
                                className="tt"
                                ref={this.toolTipRef}
                                style={{
                                  display: `${this.state.is_show_tooltip
                                    ? "block"
                                    : "none"
                                    }`,
                                }}
                              >
                                {t("TotalVolume")}.
                              </div>
                            </div>
                          </div>
                          <hr
                            className="m-0"
                            style={{
                              backgroundColor: "#303539",
                            }}
                          />
                          <div className="row pt-1 pb-1">
                            <div className="col-6">{t("Month")}</div>
                            <div className="col-6">{t("Total")}</div>
                          </div>
                          <hr
                            className="m-0"
                            style={{
                              backgroundColor: "#303539",
                            }}
                          />
                          {monthVolumne.map((item) => {
                            return (
                              <>
                                <div className="row pt-1 pb-1">
                                  <div className="col-6">{item[0]}</div>
                                  <div className="col-6">${item[1]}</div>
                                </div>
                                <hr
                                  className="m-0"
                                  style={{
                                    backgroundColor: "#303539",
                                  }}
                                />
                              </>
                            );
                          })}
                          <div
                            className="position-absolute w-100 row m-0 d-flex align-items-center"
                            style={{
                              minHeight: "45px",
                              backgroundColor: "#3dc99f",
                              left: "0",
                              bottom: "0",
                              borderRadius: "0 0 20px 20px",
                              fontSize: "18px",
                            }}
                          >
                            <div className="col-6 font-weight-bold">{t("Total")}</div>
                            <div className="col-6 font-weight-bold">
                              {/*$*/}
                              {/*{monthVolumne.reduce(*/}
                              {/*  (accumulator, currentValue) => {*/}
                              {/*    return (*/}
                              {/*      formatNumberDecimal(Number(accumulator || 0) + Number(currentValue[1] || 0))*/}
                              {/*    );*/}
                              {/*  },*/}
                              {/*  0*/}
                              {/*)}*/}
                              ${vip_data?.sum_volume_month || 0}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* liên hệ */}
                      <div
                        className="row"
                        style={{
                          marginTop: "25px",
                          columnGap: "10px",
                        }}
                      >
                        <div className="col-12 col-lg-4 p-0">
                          <div
                            className="w-100"
                            style={{
                              backgroundColor: "transparent",
                              minHeight: "227px",
                              borderRadius: "20px",
                              border: "1px solid #303539",
                              padding: "16px 0px 0px 28px",
                              color: "white",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "20px",
                                fontWeight: "700",
                                color: "#fff",
                              }}
                            >
                              <span
                                className="mr-2"
                                style={{
                                  color: "#3dc99f",
                                }}
                              >
                                <i className="fas fa-headset"></i>
                              </span>
                              {t("Contact")}
                            </p>
                            <div
                              className="d-flex"
                              style={{
                                gap: "10px",
                                marginTop: "36px",
                              }}
                            >
                              <div
                                className="d-flex flex-column align-items-center"
                                style={{
                                  gap: "16px",
                                }}
                              >
                                <img src="/images/icon/bot.svg" alt="" />
                                <p style={{ fontSize: "14px" }}>Support001</p>
                              </div>
                              <div>
                                <p style={{color: "#5d606c", fontSize: "14px", margin: "0",}}>
                                  {t("EmailAddress")}
                                </p>
                                <p style={{fontSize: "14px", margin: "0",}}>
                                  contact@putex.net
                                </p>
                                <p className='mt-2' style={{color: "#5d606c", fontSize: "14px", margin: "0",}}>
                                  Telegram
                                </p>
                                <p style={{fontSize: "14px", margin: "0", color: 'rgb(61, 201, 159)'}}>
                                  <a target="_blank" href="https://t.me/telegram">t.me/telegram</a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {selected_tab === "commission" && <Commission />}
                {selected_tab === "network" && (
                  <Network
                    memberData={vip_data?.fMembers || []}
                    handleChangeTab={this.handleChangeTab}
                  />
                )}
                {selected_tab === "upgrade" && (
                  <Upgrade
                    userRank={this.state.userRanking}
                    handleUpdateUserRank={this.handleUpdateUserRank}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    memberReducer: state.memberReducer,
    appReducer: state.appReducer,
  };
}
const withSnackbar = (Component) => (props) => {
  const { enqueueSnackbar } = useSnackbar();
  return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
  fetchingUser,
  fetchingUserSuccess,
})(withRouter(withTranslation()(withSnackbar((Affiliate)))));
